export default function BadgeStatus({
  isActive,
  activeText = 'Active',
  inactiveText = 'Inactive'
}) {
  return (
    <span
      style={{
        background: isActive
          ? 'var(--comp-badge-color-background-success-subtle, #D1FADF)'
          : 'var(--color-palette-red-025, #FEE4E2)',
        color: isActive
          ? 'var(--comp-alert-color-content-success, #3D8C4E)'
          : 'var(--color-functional-content-error, #B42318)',
        padding: '10px',
        borderRadius: 4,
        fontSize: 12,
        fontWeight: 500,
        height: 22,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      {isActive ? activeText : inactiveText}
    </span>
  )
}
